<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-xs-12">

				<h2>
					<i class="fa fa-fire text-success"></i>
					<span>大文件上传</span>
				</h2>
			</div>
		</div>

		<div class="row">

			<div class="col-md-12">
				<NbTank :tank="tank"/>
			</div>

			<div class="col-md-12">
				{{tank.name}}
			</div>
			<div class="col-md-12">
				{{tank.url}}
			</div>

		</div>


	</div>

</template>
<script>
	import NbTank from '../../../common/widget/NbTank.vue'
	import {MessageBox, Notification} from 'element-ui'
	import Tank from  "../../../common/model/tank/Tank"

	export default {

		data(){
			return {
				tank: new Tank("*", false, 1024 * 1024 * 1024, "您可以上传任意文件，大小不超过1M。")
			}
		},
		components: {
			NbTank
		},
		computed: {},
		watch: {},
		methods: {},
		mounted(){

		}
	}

</script>



// WEBPACK FOOTER //
// Upload.vue?769d1eb8